import React from "react";
import PropTypes from "prop-types";
import '../../../assets/css/ProfileImage.css';
import defaultAvatar from '../../../assets/icons/ic_default_user.svg';
import ImageHelper from "../../../utilities/helpers/ImageHelper";

const ProfileImage = ({ photo, name, size, styleObject,isDefaultUser,isBorder }) => {
    const getInitials = (name) => {
        if (!name) return "";
        return name
            .split(" ")
            .map((part) => part[0])
            .join("")
            .toUpperCase()
            .slice(0, 2);
    };

    const calculateSize = (size) => {
        if (!size || !size.width) return;
    
        switch (size.width) {
            case 16:
                return { width: "10px", height: "10px" };
            case 24:
                return { width: "14px", height: "14px" };
            case 32:
                return { width: "18px", height: "18px" };
            case 40:
                return { width: "20px", height: "20px" };
            case 48:
                return { width: "24px", height: "24px" };
            case 120:
                return { width: "48px", height: "48px" };
            case 160:
                return { width: "64px", height: "64px" };
            default:
                return { width: "20px", height: "20px" };
        }
    };
    
    return (
        <div className={`avatar-container d-flex justify-center items-center ${photo ? "" : name ? "avatar-name" : isDefaultUser ? "avatar-anonymous" : "avatar-anonymous-photo"}${isBorder ? " avatar-border" : '' }`} style={{ width: `${size.width}px`,height: `${size.height}px`,...styleObject}}>
            {photo ? (
                <img src={ImageHelper.getFullImageUrl(photo)} alt="User Avatar" className="avatar-photo" />
            ) : name ? (
                <span style={{fontSize: `${size.fontSize}px`,lineHeight: `${size.lineHeight}px`}}>{getInitials(name)}</span>
            ) : (
                <>
                    {
                        isDefaultUser === true ? (
                            <img style={{...calculateSize(size)}} src={defaultAvatar} alt="User Avatar" className="avatar-photo-default" />
                        ) : (
                            <div style={{...calculateSize(size)}}></div>
                        )
                    }
                </>
            )}
        </div>
    );
};

ProfileImage.propTypes = {
    photo: PropTypes.string,
    name: PropTypes.string,
    styleObject: PropTypes.object,
    isDefaultUser: PropTypes.bool
};

ProfileImage.defaultProps = {
    photo: null,
    name: null,
    size: {
        width: 40,
        height: 40,
        fontSize: 14,
        lineHeight: 16
    },
    styleObject: {},
    isDefaultUser: true,
    isBorder: false
};

export default ProfileImage;